import { Box, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import {
  AppleLoginButton,
  GoogleLoginButton,
  MicrosoftLoginButton,
} from 'react-social-login-buttons';
import { Auth, CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';

const PREFIX = 'SocialButtons';

const classes = {
  container: `${PREFIX}-container`,
};

const Root = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    width: '100%',
  },
}));

export default function SocialButtons() {
  const { t } = useTranslation('common');
  const theme = useTheme();
  const inlineButtonStyle = {
    width: '100%',
    fontSize: '16px',
    fontWeight: 600,
    display: 'flex',
    justifyContent: 'center',
    boxShadow: theme.shadows[2],
    fontFamily: 'Source Sans Pro',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.lightTextPrimary.main,
  };

  const activeStyle = {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.lightTextPrimary.main,
  };

  return (
    <Root className={classes.container}>
      <GoogleLoginButton
        text={t('member.continueWithGoogle')}
        onClick={() => {
          Auth.federatedSignIn({
            customProvider: CognitoHostedUIIdentityProvider.Google,
          });
        }}
        style={inlineButtonStyle}
      />

      <MicrosoftLoginButton
        text={t('member.continueWithMicrosoft')}
        onClick={() => {
          Auth.federatedSignIn({
            customProvider: 'Microsoft',
          });
        }}
        style={inlineButtonStyle}
        activeStyle={activeStyle}
      />

      <AppleLoginButton
        text={t('member.continueWithApple')}
        onClick={() => {
          Auth.federatedSignIn({
            customProvider: CognitoHostedUIIdentityProvider.Apple,
          });
        }}
        style={inlineButtonStyle}
      />
    </Root>
  );
}
